<script setup lang="ts">
// fixtures
import { languages } from '@/locales/fixtures';

/********************
 * PROPS & EMITS     *
 ********************/
const showOriginal = defineModel<boolean>({ required: true });
export interface CiToggleTranslationProps {
  language: string;
  theme?: string;
}
const props = withDefaults(defineProps<CiToggleTranslationProps>(), { theme: 'dark' });

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

/********************
 * REFS & VARS       *
 ********************/
const i18nShowOriginal = computed(() => {
  return $gettext('Show original (%{language})', { language: getLanguageName(props.language || 'de') }, true);
});

const infoTextClasses = computed(() => {
  if (props.theme === 'light') {
    return '';
  }
  return 'text-dark';
});

const buttonClasses = computed(() => {
  if (props.theme === 'light') {
    return 'italic';
  }
  return 'text-primary';
});

/********************
 * FUNCTIONS        *
 ********************/
function getLanguageName(lang: string): string {
  return $gettext(languages.filter(l => l.code === lang.toLowerCase())[0]?.name || 'German');
}
function toggleLanguage() {
  showOriginal.value = !showOriginal.value;
}
</script>

<template>
  <div class="text-sm">
    <span v-if="!showOriginal" class="mr-1" :class="infoTextClasses">{{ $gettext('Automatically translated.') }}</span>
    <button class="button button--link font-normal" :class="buttonClasses" @click="toggleLanguage()">
      <span v-if="showOriginal">{{ $gettext('Show translation') }}</span>
      <span v-else>{{ i18nShowOriginal }}</span>
    </button>
  </div>
</template>
